import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnDestroy,
} from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

import { PermissionsService } from "src/app/shared/services/permissions/permissions.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnDestroy {
  isProposalPDFView = false;
  private unsubscribeAll = new Subject<void>();
  rights = {
    isCanSearchGroups: this.permissionsService.canSearchGroups(),
    isCanViewAncillaryManager:
      this.permissionsService.canViewAncillaryManager(),
    isCanViewCalc: this.permissionsService.canViewCalc(),
  };

  clearLocalstorage() {
    localStorage.clear();
  }

  constructor(
    private permissionsService: PermissionsService,
    private router: Router,
    private cdr: ChangeDetectorRef,
  ) {
    this.router.events
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe((event: any) => {
        if (event instanceof NavigationEnd) {
          this.isProposalPDFView = false;
          if (
            event.url &&
            event.url.indexOf("/main/quoting/generate-proposal-pdf") > -1
          ) {
            this.isProposalPDFView = true;
          }
          this.cdr.markForCheck();
        }
      });
  }

  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
}
